<template>
  <div class="login-container" >
    <el-container>
      <el-header>
        <h1 style="color:#002423">数据中心管理后台</h1>
      </el-header>
      <el-main>
        <el-form>
          <el-form-item>
            <el-input type="text" v-model.trim="username" placeholder="用户名"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input type="password" v-model.trim="password" placeholder="密码" @keyup.enter.native="handleUserLogin"></el-input>
          </el-form-item>
          <!-- <el-form-item>
            <el-input type="password" v-model.trim="code" placeholder="暗号" @keyup.enter.native="handleUserLogin"></el-input>
          </el-form-item> -->
          <el-form-item>
            <el-button type="primary" @click="handleUserLogin" style="background-color:#007B39;border-color:#007B39">登录</el-button>
          </el-form-item>
        </el-form>
      </el-main>
    </el-container>
  </div>
</template>

<script>
  export default {
    name: 'vLogin',
    data(){
      return{
        username:'',
        password:'',
        code:'',
      }
    },
    created(){},
      methods:{
        handleUserLogin(){
            
            this.axios.post('/sysuser/login',{username:this.username,password:this.password}).then(res=>{
            if(res.data.code == 1){
              sessionStorage.setItem('username',res.data.data.user);
              localStorage.removeItem('router')
              var router = res.data.data.router
              var toPath = router[0].path
              this.$router.push(toPath)
            }else{
              this.$message.error(res.data.msg)
            }
          })
        },
      },
      mounted(){
        // 跳转至统一登录后台
        window.location.href = 'https://imadmin.iimedia.com.cn/iimediaAdmin/#/'
      }
  }
</script>


<style lang="scss">
  .login-container{
    width: 100%;
    height: 100%;
    // background: #002423;
    background: url('~@/assets/loginbg.jpg') no-repeat fixed center;
    position: relative;
    background-size: cover;
    h1{
      color: #fff;
      font-weight: normal;
    }
    input,
    input:focus{
      width: 360px;
      -webkit-appearance: none;
      border: 1px solid rgba(255, 255, 255, 0.1);
      background: rgba(0, 0, 0, 0.1);
      border-radius: 5px;
      color: #eee;
    }
    button{
      width: 360px;
    }
    .el-container{
      padding: 0 0 40px;
      text-align: center;
      position:absolute;
      left: 50%;
      top: 50%; 
      transform:translate(-50%,-50%);
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/public/login.vue